import React, { useState } from 'react'
import './Log_out_modal.css'
import { Button, Modal } from "react-bootstrap";
import '../successfull_modal/Successfull_Modal.css';
import Pink_Btn from '../../../common_btn/pink_btn/Pink_Btn';
import Light_Black_Btn from '../../../common_btn/light_black_btn/Light_Black_Btn';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logoutUser } from '../../../../../features/admin/auth/Slice';

const Log_out_modal = (props) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    return (
        <>
            <Modal
                className="Successfull_Modal"
                {...props}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header>{props.headtext}</Modal.Header>
                <Modal.Body>
                    <p className="top_text">{props.successfultext}</p>

                    <div className='row justify-content-center my-5'>
                        <div className='col-md-4 col-6'>
                            <Pink_Btn btnText={'Yes'} onClick={() => {
                                dispatch(logoutUser()); window.location.href = "/";
                            }} />
                        </div>
                        <div className='col-md-4 col-6'>
                            <Light_Black_Btn btnText={'No'} onClick={props.onHide} />
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default Log_out_modal